export default __webpack_public_path__ + "static/media/dropship.b52fa0a1.jpg";